import type { Renderer2 } from '@angular/core';
import type { MaybeAsync } from '@angular/router';
import type { Observable } from 'rxjs';
import { from, isObservable } from 'rxjs';
import { ONYX_ICONS } from '../components/icons/constants';
import type { OnyxIconName } from '../components/icons/interfaces';
import type { OnyxValues } from '../interfaces';

export class UtilityHelper {
  public static maybeAsyncToObservable<T>(input: MaybeAsync<T>): Observable<T> {
    return isObservable(input) ? input : from(Promise.resolve(input));
  }

  public static djb2Hash(input: string): number {
    let hash = 5381;
    for (const char of input) {
      hash = (hash << 5) + hash + char.charCodeAt(0);
    }
    return hash >>> 0;
  }

  public static toCompareString(input: string): string {
    return input.replace(/\s/g, '').toLowerCase();
  }

  public static isOnyxIcon(value: string): value is OnyxIconName {
    return Object.values(ONYX_ICONS)
      .flat()
      .includes(value as unknown as OnyxIconName);
  }

  public static isEmoji(value: string): value is string {
    const EMOJI_REGEXP = /^[0-3][0-9A-F]{3,4}(-[0-9A-F]{4,5})*$/i;
    return EMOJI_REGEXP.test(value);
  }

  public static isEnum<T extends Record<string, string>>(
    enumType: T,
    value: unknown,
  ): value is OnyxValues<T> {
    return Object.values(enumType).includes(value as OnyxValues<T>);
  }

  public static toggleClass(
    renderer: Renderer2,
    element: HTMLElement,
    className: string,
    force?: boolean,
  ): void {
    force ??= !element.classList.contains(className);
    force
      ? renderer.addClass(element, className)
      : renderer.removeClass(element, className);
  }
}
